import ReactECharts from 'echarts-for-react';

export type Series = {
  name: string;
  data: number[];
  dashed?: boolean;
};

export default function LineChart({ categories, series, yName }: { categories: string[]; series: Series[]; yName?: string; }) {
  const option = {
    tooltip: { trigger: 'axis' },
    grid: { left: 48, right: 16, top: 24, bottom: 40 },
    legend: { top: 0 },
    xAxis: { type: 'category', data: categories },
    yAxis: { type: 'value', name: yName ?? 'Net' },
    series: series.map(s => ({
      name: s.name,
      type: 'line',
      smooth: true,
      symbol: 'circle',
      symbolSize: 6,
      lineStyle: s.dashed ? { type: 'dashed' } : undefined,
      data: s.data
    }))
  };

  return (
    <div className="w-full">
      <ReactECharts option={option} style={{ height: 380, width: '100%' }} notMerge lazyUpdate />
    </div>
  );
}


